export default "__VITE_ASSET__CNX0$wGI__"